// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import Toggle, { ToggleOptions } from './Toggle';

export type { ToggleOptions };
export default Toggle;
